import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  root: { flex: 1, backgroundColor: theme.COLOR_BG_BASE },
  content: { flex: 1, justifyContent: 'center', paddingHorizontal: rw(24), gap: rh(20) },
  action: { paddingHorizontal: rw(24), paddingVertical: rh(24) },
}))
